import { ImageWrapper } from '../../../common/wrappers/ImageWrapper';
import MTinderCarousel from '../carousels/MTinderCarousel';
import React, { useState } from 'react';
import cross from '../../../../assets/images/games/m-game/cross.webp';
import heart from '../../../../assets/images/games/m-game/heart.webp';
import image11 from '../../../../assets/images/games/m-game/tinder/1harry/1.webp';
import image12 from '../../../../assets/images/games/m-game/tinder/1harry/2.webp';
import image13 from '../../../../assets/images/games/m-game/tinder/1harry/3.webp';

import image21 from '../../../../assets/images/games/m-game/tinder/2peter/1.webp';
import image22 from '../../../../assets/images/games/m-game/tinder/2peter/3.webp';
import image23 from '../../../../assets/images/games/m-game/tinder/2peter/4.webp';
import image24 from '../../../../assets/images/games/m-game/tinder/2peter/5.webp';

import image31 from '../../../../assets/images/games/m-game/tinder/3emma/1.webp';
import image32 from '../../../../assets/images/games/m-game/tinder/3emma/2.webp';
import image33 from '../../../../assets/images/games/m-game/tinder/3emma/3.webp';
import image34 from '../../../../assets/images/games/m-game/tinder/3emma/4.webp';
import image35 from '../../../../assets/images/games/m-game/tinder/3emma/5.webp';

import image41 from '../../../../assets/images/games/m-game/tinder/4doggo/1.webp';
import image42 from '../../../../assets/images/games/m-game/tinder/4doggo/2.webp';
import image43 from '../../../../assets/images/games/m-game/tinder/4doggo/3.webp';

import image51 from '../../../../assets/images/games/m-game/tinder/5benson/1.webp';
import image52 from '../../../../assets/images/games/m-game/tinder/5benson/2.webp';
import image53 from '../../../../assets/images/games/m-game/tinder/5benson/3.webp';
import image54 from '../../../../assets/images/games/m-game/tinder/5benson/4.webp';
import image55 from '../../../../assets/images/games/m-game/tinder/5benson/5.webp';
import image56 from '../../../../assets/images/games/m-game/tinder/5benson/6.webp';

import image61 from '../../../../assets/images/games/m-game/tinder/6ja/1.webp';
import image62 from '../../../../assets/images/games/m-game/tinder/6ja/2.webp';
import image63 from '../../../../assets/images/games/m-game/tinder/6ja/3.webp';
import image63Ring from '../../../../assets/images/games/m-game/tinder/6ja/ring2.webp';
import image64 from '../../../../assets/images/games/m-game/tinder/6ja/4.webp';
import image65 from '../../../../assets/images/games/m-game/tinder/6ja/5.webp';

import MContinueButton from '../MContinueButton';
import MDiaryIcon from '../MDiaryIcon';
import imageLast from '../../../../assets/images/games/m-game/tinder/6ja/last.webp';
import imageLast2 from '../../../../assets/images/games/m-game/tinder/6ja/ring.webp';
import logo from '../../../../assets/images/games/m-game/flirtex.webp';

type Props = {
    onNext: () => void;
};

export default function MTinderCipher(props: Props) {
    const [chosen, setChosen] = useState(false);

    const [questions, setQuestions] = useState([
        {
            images: [image11, image12, image13],
            name: 'Harry 18',
            text: 'Svojho "hada" ovládam dokonalou parselčinou. Som veľmi slávny a mám rád ryšavky. #sexyscar',
            id: 101,
        },
        {
            images: [image21, image22, image23, image24],
            name: 'Peter 18',
            text: 'Hľadám niekoho s vlastným Deadpool kostýmom. Šampión v turnaji Floor is Lava 2019.',
            id: 102,
        },
        {
            images: [image31, image32, image33, image34, image35],
            name: 'Popoluška 19',
            text: "Started from the bottom now we're here. Sklenené črievičky sú fakt nepríjemné, radšej by som mala mačacie labky.",
            id: 103,
        },
        {
            images: [image41, image42, image43],
            name: 'Doggo 6',
            text: 'Ak si na zlých chlapcov, swipni doľava pretože ja som dobrý chlapec. Rád experimentujem s účesmi. #makeover',
            id: 104,
        },
        {
            images: [image51, image52, image53, image54, image55, image56],
            name: 'Purrfessor Benson 4',
            text: 'Mám rád mliečko a cool kostýmy. Rád si dlho pospím a mňaukám. Upozornenie: veľmi chlpatý',
            id: 105,
        },
        {
            images: [image61, image62, image63, image63Ring, image64, image65],
            name: 'Maroš 26',
            text: 'Ajťák zo Slovenska, mám rád knihy, šport a mačky. Nechcem deti a budem ťa zahlťovať divnými faktami a postrehmi, ktoré ti možno prídu nudné alebo vtipné.',
            id: 106,
        },
        { url: imageLast, id: 100 },
    ]);

    const [answers, setAnswers] = useState([
        { id: 101 },
        { id: 102 },
        { id: 103 },
        { id: 104 },
        { id: 105 },
        { id: 106 },
    ]);

    const removeOnIndex = (cond: boolean) => {
        // @ts-expect-error
        const filteredQuestions = questions.filter((v, i) => i !== 0);
        // @ts-expect-error
        const filteredAnswers = answers.filter((v, i) => i !== 0);
        setQuestions(filteredQuestions);
        setAnswers(filteredAnswers);
        setChosen(cond);
    };
    return (
        <React.Fragment>
            <div className="m-tinder">
                <div className="m-cipher-image">
                    <ImageWrapper src={logo} alt="logo" shouldScroll={true} allowLightbox={false} />
                </div>
                {questions && questions.length > 1 && <MTinderCarousel images={questions} />}
                {answers && questions && questions.length > 1 && answers.length > 0 && (
                    <div className="m-tinder-icons-wrapper">
                        <div className="m-tinder-icon no">
                            <img src={cross} alt="no" onClick={() => removeOnIndex(false)} />
                        </div>
                        <div className="m-tinder-icon yes">
                            <img src={heart} alt="yes" onClick={() => removeOnIndex(true)} />
                        </div>
                    </div>
                )}
                {!questions ||
                    (questions.length === 1 && (
                        <div className="m-tinder-solved">
                            {chosen && (
                                <div className="inner">
                                    <div className="m-cipher-image">
                                        <ImageWrapper
                                            src={imageLast}
                                            alt="logo"
                                            shouldScroll={true}
                                            allowLightbox={false}
                                        />
                                    </div>
                                    <div className="m-cipher-image">
                                        <ImageWrapper
                                            src={imageLast2}
                                            alt="logo"
                                            shouldScroll={true}
                                            allowLightbox={false}
                                        />
                                    </div>
                                    <MContinueButton text="Vyberám si teba" onClick={props.onNext} />
                                    <MDiaryIcon />
                                </div>
                            )}
                            {!chosen && (
                                <div className="inner">
                                    <MContinueButton text="Nevyberám si teba" onClick={props.onNext} />
                                </div>
                            )}
                        </div>
                    ))}
            </div>
        </React.Fragment>
    );
}
